import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=036089a9&"
import script from "./Loading.ts?vue&type=script&lang=ts&"
export * from "./Loading.ts?vue&type=script&lang=ts&"
import style0 from "./Loading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports